<template>
  <b-modal
    id="timesheet-editor"
    ref="timesheet-editor"
    size="xl-size"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
    @hide="onModalHide"
  >
    <div class="modal-head">
      <h2 class="modal-title">
          {{label.get('timesheet_editor')}}
      </h2>
    </div>
    <div class="content-wrapper timesheet-editor-modal">
      <div class="content-list">
        <div class="table-header modal-table">
          <span class="column-header date">{{label.get('date')}}</span>
          <span class="column-header clock">{{label.get('clock_in')}}</span>
          <span class="column-header clock mr-68">{{label.get('clock_out')}}</span>
          <span class="column-header clock">{{label.get('break_start')}}</span>
          <span class="column-header clock mr-68">{{label.get('break_end')}}</span>
          <span class="column-header job">{{label.get('job_code')}}</span>
          <span class="column-header clock">{{label.get('job_start')}}</span>
          <span class="column-header clock mr-76">{{label.get('job_end')}}</span>
          <span class="column-header notes">{{label.get('notes')}}</span>
        </div>
        <div class="table-content">
          <ul class="logs-list days">
            <li class="no-entry">
              <div class="no-entries">
                <div class="day-log">
                  <div class="field-row">
                    <div class="field-details date">
                      <div class="calendar-icon">
                        <span class="day">Tue</span>
                        <span class="date">9/31</span>
                      </div>
                    </div>
                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button class="add-btn">
                        <i class="atto atto-add-more" />
                      </button>
                    </div>

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button class="add-btn">
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details jobs-holder">
                      <select-dropdown-component
                        :value="selectedJob"
                        :options="jobs"
                        placeholder="Select Job Code"
                        empty-options-hint="No Job Codes"
                        class="job"
                        @onOptionSelected="onJobSelected"
                      />
                    </div>

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details">
                      <button
                        type="reset"
                        class="clear-entry notes"
                        @click="addNote"
                      >
                        <i class="atto atto-notes-lt" />
                      </button>
                      <button
                        type="reset"
                        class="clear-entry close-btn"
                      >
                        <i class="atto atto-close-btn" />
                      </button>
                    </div>
                  </div>

                  <div class="field-row">
                    <div class="field-details date" />
                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>

                    <div class="field-details timepicker-holder" />

                    <div class="field-details jobs-holder" />
                    <div class="field-details timepicker-holder" />

                    <div class="field-details">
                      <button
                        type="reset"
                        class="clear-entry notes"
                        @click="addNote"
                      >
                        <i class="atto atto-notes-lt" />
                      </button>
                      <button
                        type="reset"
                        class="clear-entry close-btn"
                      >
                        <i class="atto atto-close-btn" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="no-entry">
              <div class="no-entries">
                <div class="day-log">
                  <div class="field-row">
                    <div class="field-details date">
                      <div class="calendar-icon">
                        <span class="day">Tue</span>
                        <span class="date">9/31</span>
                      </div>
                    </div>
                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details jobs-holder">
                      <select-dropdown-component
                        :value="selectedJob"
                        :options="jobs"
                        placeholder="Select Job Code"
                        empty-options-hint="No Job Codes"
                        class="job"
                        @onOptionSelected="onJobSelected"
                      />
                    </div>

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details">
                      <button
                        type="reset"
                        class="clear-entry notes"
                        @click="addNote"
                      >
                        <i class="atto atto-notes-lt" />
                      </button>
                      <button
                        type="reset"
                        class="clear-entry close-btn"
                      >
                        <i class="atto atto-close-btn" />
                      </button>
                    </div>
                  </div>
                  <div class="field-row">
                    <div class="field-details date" />
                    <div class="field-details timepicker-holder" />

                    <div class="field-details timepicker-holder" />
                    <div class="field-details jobs-holder">
                      <select-dropdown-component
                        :value="selectedJob"
                        :options="jobs"
                        placeholder="Select Job Code"
                        empty-options-hint="No Job Codes"
                        class="job"
                        @onOptionSelected="onJobSelected"
                      />
                    </div>

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details">
                      <button
                        type="reset"
                        class="clear-entry notes"
                        @click="addNote"
                      >
                        <i class="atto atto-notes-lt" />
                      </button>
                      <button
                        type="reset"
                        class="clear-entry close-btn"
                      >
                        <i class="atto atto-close-btn" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="no-entry">
              <div class="no-entries">
                <div class="day-log">
                  <div class="field-row">
                    <div class="field-details date">
                      <div class="calendar-icon">
                        <span class="day">Mon</span>
                        <span class="date">9/30</span>
                      </div>
                    </div>
                    <div class="field-details">
                      <a
                        href="javascript:void(0)"
                        class="add-weekend-entry"
                      >
                        <i class="atto atto-add-more" />
                      </a>
                      <span class="add-time-entry">{{label.get('add_time_entry')}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="no-entry">
              <div class="no-entries">
                <div class="day-log">
                  <div class="field-row">
                    <div class="field-details date">
                      <div class="calendar-icon">
                        <span class="day">Mon</span>
                        <span class="date">9/30</span>
                      </div>
                    </div>
                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details jobs-holder">
                      <select-dropdown-component
                        :value="selectedJob"
                        :options="jobs"
                        placeholder="Select Job Code"
                        empty-options-hint="No Job Codes"
                        class="job"
                        @onOptionSelected="onJobSelected"
                      />
                    </div>

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details">
                      <button
                        type="reset"
                        class="clear-entry notes"
                        @click="addNote"
                      >
                        <i class="atto atto-notes-lt" />
                      </button>
                      <button
                        type="reset"
                        class="clear-entry close-btn"
                      >
                        <i class="atto atto-close-btn" />
                      </button>
                    </div>
                  </div>



                  <div class="field-row">
                    <div class="field-details date" />
                    <div class="field-details timepicker-holder" />

                    <div class="field-details timepicker-holder">
                      <div class="in">
                        <time-picker-component />
                      </div>
                      <i class="atto atto-rdir-arrow-b" />
                      <div class="out">
                        <time-picker-component />
                      </div>
                      <button
                        type="reset"
                        class="add-btn"
                      >
                        <i class="atto atto-add-more" />
                      </button>
                    </div>
                    <div class="field-details jobs-holder" />

                    <div class="field-details timepicker-holder" />
                    <div class="field-details">
                      <button
                        type="reset"
                        class="clear-entry notes has-note"
                        @click="addNote"
                      >
                        <i class="atto atto-notes-lt" />
                      </button>
                      <button
                        type="reset"
                        class="clear-entry close-btn"
                      >
                        <i class="atto atto-close-btn" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="reset"
        class="atto-btn cancel"
        @click="cancel"
      >
          {{label.get('cancel')}}
      </button>
      <button
        type="submit"
        class="atto-btn submit"
        @click="saveChanges"
      >
          {{label.get('save_changes')}}
      </button>
    </div>
    <timesheet-notes-component v-if="addNotes" />
  </b-modal>
</template>

<script>
    import SelectDropdownComponent from "../../../shared/components/SelectDropdownComponent";
    import TimePickerComponent from "../shared/components/TimePickerComponent";
    import TimesheetNotesComponent from "./TimesheetNotesComponent";
    export default {
        name: "TimesheetEditorComponent",
        components: {
            SelectDropdownComponent,
            TimePickerComponent,
            TimesheetNotesComponent
        },
        data(){
            return{
                selectedJob: "Landscaping",
                jobs: [
                    {
                        value: 0,
                        label: "Landscaping"
                    },
                    {
                        value: 1,
                        label: "Masonry"
                    },
                    {
                        value: 2,
                        label: "Gardening"
                    },
                    {
                        value: 3,
                        label: "Grasshopper"
                    },
                    {
                        value: 4,
                        label: "Chicken Tortilla"
                    }
                ],
                addNotes: false
            }
        },
        mounted(){
            document.body.appendChild(this.$el);
            this.$refs['timesheet-editor'].show();

            this.$root.$on('hideTimesheetNotes', this.closeTimesheetNotes);
        },
        beforeDestroy() {
            this.$root.$off('hideTimesheetNotes');
        },
        methods: {
            cancel(){
                this.$refs['timesheet-editor'].hide();
            },
            onModalHide(){
                this.$root.$emit('hideTimesheets');
            },
            saveChanges(){
            },
            onJobSelected(){
            },
            addNote(){
                // this.$root.$emit('addNote');
                this.addNotes = true;
            },
            closeTimesheetNotes(){
                this.addNotes = false;
            }
        }
    }

</script>

<style lang="scss" scoped>
    .table-header{
        span{
            &.column-header{
                margin-right: 0;
                &.date{
                    width: 40px;
                    margin-right: 20px;
                }
                &.clock{
                    width: 80px;
                    margin-right: 24px;
                }
                &.mr-68{
                    margin-right: 68px;
                }
                &.mr-76{
                    margin-right: 76px;
                }
                &.job{
                    width: 184px;
                    margin-right: 24px;
                    cursor: pointer;
                }
            }
        }
    }
    .logs-list{
        li{
            .day-log {
                flex-direction: column;
                margin-right: 0 !important;
                div.calendar-icon{
                    margin-left: 0;
                }
            }
        }
    }
    .field-details{
        flex-flow: row !important;
    }
</style>

<style lang="scss">
    .edit-timesheets-btn{
        margin-right: 25px;
    }
    .modal {
        .modal-content {
            .modal-body {
                .timesheet-editor-modal {
                    .content-list{
                        overflow: auto;
                        .table-header{
                            &.modal-table{
                                display: inline-flex;
                                justify-content: flex-start;
                                max-width: 1128px;
                                padding: 5px 12px;
                            }
                        }
                        .logs-list{
                            &.days{
                                li{
                                    border-bottom: 1px solid $atto-light-grey;
                                    &.no-entry{
                                        padding: 16px 12px 0;
                                        .no-entries{
                                            .day-log{
                                                .calendar-icon{
                                                    .day{
                                                        color: $atto-font-color;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .field-row {
                        margin-bottom: 0;
                        width: 100%;
                        .field-details{
                            margin-bottom: 16px;
                            width: 100%;
                            input{
                              &.timepicker{
                                  max-width: 80px;
                              }
                            }
                            .add-btn{
                                padding: 0;
                                width: 40px;
                                height: 40px;
                                display: inline-flex;
                                align-items: center;
                                text-align: center;
                                justify-content: center;
                                border-radius: 100%;
                                cursor: pointer;
                                transition: ease all 0.3s;
                                margin-left: 3px;
                                &:hover{
                                    background-color: $atto-light-grey;
                                    i{
                                        color: $atto-not-active;
                                    }
                                }
                            }
                            .job{
                                width: 184px;
                                margin-right: 24px;
                            }
                            .atto-notes-lt{
                                margin-left: 0;
                                font-size: 17px;
                            }
                            .clear-entry{
                                &.close-btn{
                                    margin-left: 10px;
                                }
                                &.notes{
                                    margin-left: -4px;
                                    &:hover{
                                        .atto-notes-lt{
                                            &:before{
                                                color: $atto-not-active;
                                            }
                                        }
                                    }
                                    &.has-note{
                                        &:after{
                                            content:'';
                                            width: 8px;
                                            height: 8px;
                                            border-radius: 50%;
                                            position: absolute;
                                            background-color: $atto-teal;
                                            margin: -8px 8px;
                                        }
                                    }
                                }
                            }
                            &.date{
                                min-width: 60px;
                                width: 60px;
                            }
                            &.timepicker-holder{
                                min-width: 252px;
                            }
                            &.jobs-holder{
                                min-width: 208px;
                            }
                            .add-weekend-entry{
                                margin-left: 0;
                                .atto-add-more{
                                    margin: auto;
                                }
                            }
                            span.add-time-entry{
                                color: $atto-not-active;
                                font-size: 14px;
                                line-height: 24px;
                                font-family: "Roboto", sans-serif;
                                font-weight: 500;
                                padding-left: 16px;
                            }
                        }
                    }
                }
            }
        }
    }

</style>